import {Injectable} from "@angular/core";

@Injectable()
export class SessionService {
    setBadBrowserPopinOpen(alreadySeen: boolean) {
        sessionStorage.setItem('badBrowserPopinOpen', alreadySeen + '');
    }

    getBadBrowserPopinOpen(): boolean {
        const alreadySeen: any = sessionStorage.getItem('badBrowserPopinOpen');
        if (alreadySeen != null) {
            return Boolean(alreadySeen);
        }
        return false;
    }
}
